import { ISelect } from '../SelectV2/types'
import * as React from 'react'
import ReactTooltip from 'react-tooltip'
import './styles.scss'

interface InputIconProps {
  value?: string
  isNotDeleteButton?: boolean
  isOpenOptions?: boolean
  multi?: boolean
  onResetInput: () => void
  handleOnClickCaret: (event: any) => void
}

const IconValidate = () => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 2.99965L3.00035 6L8.00047 0.999882L6.99988 0L3.00035 4.00024L0.999882 1.99976L0 2.99965Z" fill="#FAFAFE"/>
  </svg>
)
const IconCaretAll = () => (
  <svg width="8" height="1" viewBox="0 0 8 1" xmlns="http://www.w3.org/2000/svg"><line x1="0.5" y1="0.5" x2="7.5" y2="0.5" stroke="#1F2534" strokeLinecap="round"></line></svg>
)

const IconCaret = () => (
  <svg width="14" height="7" viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.1918 5.32012C9.04136 3.6338 10.8911 1.94772 12.747 0.267198C12.8654 0.159995 13.0221 0.0627815 13.1799 0.0221966C13.4753 -0.0538328 13.7682 0.0844627 13.9124 0.320842C14.0584 0.560123 14.0201 0.837129 13.8104 1.04984C13.775 1.08574 13.7357 1.11857 13.6982 1.15273C11.6593 3.00861 9.62058 4.86453 7.58158 6.72028C7.17432 7.09094 6.82616 7.09322 6.42396 6.72717C4.37425 4.86163 2.32564 2.99518 0.274255 1.13117C0.0988813 0.971817 -0.0244404 0.796336 0.00411308 0.565139C0.034306 0.320676 0.172747 0.136365 0.431595 0.0475673C0.694542 -0.0426813 0.940458 -0.00603463 1.14953 0.170566C1.28847 0.287926 1.4194 0.413246 1.55352 0.535333C3.30238 2.12768 5.05134 3.71998 6.79934 5.31312C6.85818 5.36672 6.90704 5.4294 7.01215 5.54419C7.09294 5.44229 7.13356 5.37319 7.1918 5.32012Z"/>
  </svg>
)
const IconCaretUp = () => (
  <svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title>ionicons-v5-b</title><path d="M414,321.94,274.22,158.82a24,24,0,0,0-36.44,0L98,321.94c-13.34,15.57-2.28,39.62,18.22,39.62H395.82C416.32,361.56,427.38,337.51,414,321.94Z"/></svg>
)
const IconCaretDown = () => (
  
<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.1018 8C5.02785 8 4.45387 9.2649 5.16108 10.0731L10.6829 16.3838C11.3801 17.1806 12.6197 17.1806 13.3169 16.3838L18.8388 10.0731C19.5459 9.2649 18.972 8 17.898 8H6.1018Z" fill="#656a75"/>
</svg>

)
const IconClose = () => (
  <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32">
    <circle className="st0" cx="16" cy="16" r="15.4"/>
    <path className="st1" d="M17.4,16l4.2,4.2c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L16,17.5l-4.2,4.2c-0.4,0.4-1,0.4-1.4,0
    c-0.4-0.4-0.4-1,0-1.4l4.2-4.2l-4.2-4.2c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l4.2,4.2l4.2-4.2c0.4-0.4,1-0.4,1.4,0
    c0.4,0.4,0.4,1,0,1.4L17.4,16z M4.7,27.4c-6.2-6.2-6.2-16.4,0-22.6c6.2-6.2,16.4-6.2,22.6,0c6.2,6.2,6.2,16.4,0,22.6
    C21.1,33.6,10.9,33.6,4.7,27.4z M6.1,25.9c5.5,5.5,14.3,5.5,19.8,0c5.5-5.5,5.5-14.3,0-19.8c-5.5-5.5-14.3-5.5-19.8,0
    C0.6,11.6,0.6,20.5,6.1,25.9z"/>
  </svg>
)

const InputIcon = (props: InputIconProps) => {
  const { value, onResetInput, multi, isNotDeleteButton, isOpenOptions, handleOnClickCaret } = props
  const isInitialValueExist = value && value.length > 0

  if (isInitialValueExist && (multi || !isNotDeleteButton)) {
    return (
      <div
        className="inputSelect__icon inputSelect__icon--close"
        onClick={onResetInput}
      >
        <IconClose />
      </div>
    )
  }
  if(!isNotDeleteButton) {

    return (
      <div className="inputSelect__icon">
        <IconCaret />
      </div>
    )
  }

  return (
    <div onClick={handleOnClickCaret} className={`inputSelect__icon ${isNotDeleteButton ? 'inputSelect__icon--open': ''}`}>
      {isOpenOptions ? <IconCaretUp />: <IconCaretDown />}
    </div>
  )
}

interface InputDropdownProps {
  options?: ISelect[]
  allOptions?: ISelect[]
  selectedOptions: ISelect[]
  isOpenOptions: boolean
  multi?: boolean
  isNotDeleteButton?: boolean
  onSelectedOptions: (selectedOptions: ISelect[]) => void
}

const InputDropdown = (props: InputDropdownProps) => {
  const { options = [], onSelectedOptions, selectedOptions, isOpenOptions, multi = false, isNotDeleteButton, allOptions } = props
  const onClickElement = (event: MouseEvent, currentValue: ISelect) => {
    event.stopPropagation()
    let elements: ISelect[] | [] = []
    const currentElementAlreadyExist = selectedOptions.some(option => option.value === currentValue.value)
    if(!currentElementAlreadyExist && currentValue.parentId) {
      const selectedParent = selectedOptions.find(option => option.value === currentValue.parentId)
      const isAnySelectedChild = selectedOptions.some(option => option?.parentId === currentValue.parentId)
      if(selectedParent && !isAnySelectedChild) {
        const selectedChilds = allOptions?.filter(option => {
          return option?.parentId === currentValue.parentId && (option.value !== currentValue.value)
        })

        if(selectedChilds?.length) {
          elements = [...elements, ...selectedChilds]
          return onSelectedOptions(elements)
        }
      }
    }
    // if parentId & selectedOptions has hasChildren & value === parentId and zero child in selected options => its unselect 
    if (currentElementAlreadyExist && !isNotDeleteButton) {
      if(currentValue.hasChildren) {
        elements = selectedOptions.filter(option => {
          return option.parentId !== currentValue.value && option.value !== currentValue.value
        })
        
      } else {
        elements = selectedOptions.filter(option => option.value !== currentValue.value)
        if(currentValue.parentId) {
          const isOneChildAtLeast = elements.find(selectedOption => selectedOption.parentId === currentValue.parentId && selectedOption.value !== currentValue.value )
          if(!isOneChildAtLeast) {
            elements = elements.filter(option => option.value !== currentValue.parentId)

          }
        }
        
      }
      
      return onSelectedOptions(elements)
    }
    
    if (multi) {
      // @ts-ignore
      elements = [...selectedOptions, currentValue]
      if(currentValue.parentId) {
        const isParentAlreadySelected = selectedOptions.some(option => option.value === currentValue.parentId)
        if(!isParentAlreadySelected) {
          // @ts-ignore
          const parent = options.find(option => option.value === currentValue.parentId)
          if(parent) {
            elements = [parent, ...elements]
          }
        }
  
      }
    } else {
      elements = [currentValue]
    }

    return onSelectedOptions(elements)
  }

  if (isOpenOptions) {
    return (
      <div className="inputSelect__dropdown">
        { options.map((item, i) => {
          const isActiveElement = selectedOptions.some(option => option.value === item.value)
          const children = item?.hasChildren && options.filter(option => option.parentId === item.value) || []
          const isAllChildrenSelected = children.length && children?.every(child => selectedOptions.find(selectedOption => selectedOption.value === child.value))
          const isParentAndAnySelectedChild = item?.hasChildren && selectedOptions.some(option => option.parentId === item.value)
          const isPrtialIcon = isParentAndAnySelectedChild && item?.hasChildren && !isAllChildrenSelected
          const isParentActive = isAllChildrenSelected && item.hasChildren
          const isParentSelectedAndNoChild = !isParentAndAnySelectedChild && item?.hasChildren && isActiveElement
          const isParentSelected = selectedOptions.some(option => option.value === item?.parentId)
          const lookLikeChildren = !!item?.parentId && options.filter(option => option.parentId === item?.parentId) || []
          const isAnySelectedChild = lookLikeChildren?.some(child => selectedOptions.find(selectedOption => selectedOption.value === child.value))
          const shouldSelectAllChildren = !isActiveElement && isParentSelected && !isAnySelectedChild
          const isActive = isParentActive || isActiveElement || shouldSelectAllChildren
          return (
            <>
            <div
              data-tip
              data-for={`tooltipSelect_${item?.value}`}
              key={`${item.label}__${i}`}
              className={`${item.parentId ? 'inputSelect__dropdown__childs': ''} inputSelect__dropdown__item ${(isActive || isPrtialIcon) && isNotDeleteButton ? 'inputSelect__dropdown__temActive' : ''}`}
              onClick={(event: any) => onClickElement(event, item)}
              style={{background: isActive || isPrtialIcon ? '	#dcdcdcbd': 'transparent'}}
            >
              { multi && (
                <div className={`${item.parentId ? 'inputSelect__dropdown__checkboxChild': ''} inputSelect__dropdown__checkbox ${item?.hasChildren && !isAllChildrenSelected && !isParentSelectedAndNoChild ? 'partial' : ''} ${isActive || isPrtialIcon ? 'inputSelect__dropdown__checkbox--active' : ''}`}>
                  {isPrtialIcon? <IconCaretAll />: <IconValidate />}
                </div>
              )}
              <p>{item.label}</p>

              <ReactTooltip
                id={`tooltipSelect_${item?.value}`}
                place="bottom"
                effect="solid"
              >
                {item.label}
              </ReactTooltip>
            </div>
            </>
          )
        })}
      </div>
    )
  }

  return null
}

interface InputValuesProps {
  searchInField: string
  value: string
}

const InputValues = ({ searchInField, value }: InputValuesProps) => {
  if (searchInField.length === 0) {
    return (
      <div className="inputSelect__values">
        {value}
      </div>
    )
  }

  return null
}

function usePrevious(value: any) {
  const ref = React.useRef()
  React.useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export interface WrappedFieldMetaProps {
  active?: boolean | undefined;
  autofilled: boolean;
  asyncValidating: boolean;
  dirty: boolean;
  dispatch: any;
  error?: any;
  form: string;
  initial: any;
  invalid: boolean;
  pristine: boolean;
  submitting: boolean;
  submitFailed: boolean;
  touched: boolean;
  valid: boolean;
  visited: boolean;
  warning?: any;
}
export interface InputSelectProps {
  label?: string
  placeholder?: string
  initialValues?: string
  options?: ISelect[]
  multi?: boolean
  action?: (params: any) => void
  onChange?: (options: ISelect[]) => void
  isReset?: boolean
  isLocalFilter?: boolean
  onDropDownClose?: () => void
  styles?: React.CSSProperties
  meta?: WrappedFieldMetaProps
  isNotDeleteButton?: boolean
  compareByValue?: boolean
}

export const InputSelect = (props: InputSelectProps) => {
  const { initialValues, onChange, placeholder, options, multi, label, action, isReset, isLocalFilter, onDropDownClose,  meta, isNotDeleteButton,compareByValue, styles={} } = props
  let timer: any
  const refInput: React.MutableRefObject<any> = React.useRef()
  const [value, setValue] = React.useState(initialValues)
  const [searchInField, setSearchInField] = React.useState('')
  const [isOpenOptions, setOpenOptions] = React.useState(false)
  const [selectedOptions, setSelectedOptions] = React.useState([] as ISelect[] | [])
  const [isFirstRender, setIsFirstRender] = React.useState(true)
  const [prevSelectedOptions, setPrevSelectedOptions] = React.useState([] as ISelect[] | [])

  const isFocus = (value && value?.length > 0) ? 'inputSelect__active' : ''
  const inputPlaceholder = placeholder || 'Recherche...'
  const prevIsOpen = usePrevious(isOpenOptions)
  const getFinalSelectedData = (selectedOptions) => {
    let filterOutElt: any[] = []
    return selectedOptions.filter((elt, idx) => {
      if(idx===0) filterOutElt = []
      if(elt.hasChildren) {
        const allChildren = options?.filter(option => option.parentId === elt.value)
        if(!allChildren?.length) return true
        const AreAllChildrenSelected = allChildren.every(child => selectedOptions.find(selectedOption => selectedOption.value === child.value))
        if(AreAllChildrenSelected) {
          filterOutElt.push(elt.value)
          return true
        }
        const child = selectedOptions.some(selectedOption => selectedOption.parentId === elt.value)
        if(!child) return true
        return false
      }
      if(elt.parentId && filterOutElt.includes(elt.parentId)) {
        return false
      }
      return true
    })

  }
  const finalSelectedData = getFinalSelectedData(selectedOptions)

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange && onChange(finalSelectedData)
    setSearchInField(e.target.value)

    if (e.target.placeholder) {
      e.target.placeholder === ''
    }

    if (e.target.value !== '') {
      setOpenOptions(true)
    }
  }
  const onResetInput = () => {
    setValue('')
    onChange && onChange([])
    setSelectedOptions([])
    setPrevSelectedOptions([])
  }
  const onClickInput = () => {
    setOpenOptions(!isOpenOptions)
    setSearchInField('')
    setOpenOptions(true)
  }
  const handleOnClickCaret = (event) => {
    event.stopPropagation()
    if(!isOpenOptions) {
      action && action({ name: '' })
    }
    setOpenOptions(bool => !bool)
  }
  const onMousedownDocument = (event: MouseEvent) => {
    if (refInput && !refInput?.current?.contains(event?.target)) {
      setOpenOptions(false)
      setSearchInField('')
    }
  }

  const onSelectedOptions = (options: ISelect[]) => {
    if(action) {
      setSearchInField('')
    }
    const finalSelectedData = getFinalSelectedData(options)
    setSelectedOptions(options)
    onChange && onChange(finalSelectedData)
    setValue(finalSelectedData.map(item => item.label).join(', '))
    if(!multi) {
      setOpenOptions(false)
    }
  }

  const onFocus = () => {
    return action && action({ name: '' })
  }

  let filteredOptions = (!action || isLocalFilter) && searchInField && searchInField.length > 0 ? options?.filter(item => item.label.toLowerCase().includes(searchInField.toLowerCase())) : options
  const displayPlaceholder = value && value.length > 0 ? "" : inputPlaceholder
  const filteredOptionsParents =
    options?.filter((item) =>
      filteredOptions?.find((filteredOption) => filteredOption?.parentId === item.value || (filteredOption?.hasChildren && item.value === filteredOption.value) )
    ) || []

  if (filteredOptionsParents.length) {
    filteredOptions = filteredOptionsParents.reduce((acc, curr) => {
      const children =
        filteredOptions?.filter((filteredOption) => filteredOption?.parentId === curr.value) || []
      return [...acc, curr, ...children]
    }, [])
  }
  React.useEffect(() => {
    if(prevIsOpen && !isOpenOptions && onDropDownClose) {
      onDropDownClose()
    }

  },[isOpenOptions, isFirstRender])
  React.useEffect(() => {
    document.addEventListener('mousedown', onMousedownDocument)
    if(!isFirstRender && !action) return
    if (options) {
      const valueToCompare = compareByValue ? 'value' : 'label'

      const values = initialValues && initialValues.length > 0 ? initialValues.split(',') : []
      values.forEach((value) => {
        const item = options.find(option => {
          return value === option[valueToCompare]
        })
        if (item) {
          setPrevSelectedOptions((prevOptions) =>  {
            const isAlreadyAdded = (prevOptions as ISelect[]).find(option => option.value === item.value)
            if(isAlreadyAdded) return prevOptions
            return [...prevOptions, item]
          })
      
        }
      }, [])
    
    }
    return () => {
      document.removeEventListener("mousedown", onMousedownDocument)
  }
 
  }, [initialValues])

  React.useEffect(() => {
    setIsFirstRender(false)
  },[])

  React.useEffect(() => {
    if(!multi && prevSelectedOptions.length > 1 ) return
    if(prevSelectedOptions.length > 0) {
      setSelectedOptions(prevSelectedOptions)
      setValue((prevSelectedOptions as ISelect[]).map(item => item.label).join(', '))
    }
  },[prevSelectedOptions, multi])
  
  React.useEffect(() => {
    if (action && !isLocalFilter && searchInField.length > 0) {
      timer = setTimeout(() => {
        action({
          name: searchInField
        })
      }, 500)
    }

    return () => clearTimeout(timer)
  }, [searchInField])

  React.useEffect(() => {
    if (isReset) {
      setValue('')
      setSelectedOptions([])
      setPrevSelectedOptions([])
    }
  }, [isReset])

  return (
    <div
      onClick={onClickInput}
      className={`inputSelect ${isFocus}`}
      ref={refInput}
    >
      { label && (
        <div className="inputSelect__label">
          <p>
            <span>{label}</span>
            {multi && finalSelectedData.length > 0 && (
              <span className="inputSelect__elementsCounter">({finalSelectedData.length})</span>
            )}
          </p>
        </div>
      )}

      <div style={styles} className={`inputSelect__container ${meta?.touched && meta?.error ? 'inputSelect__error' : ''}`}>
        <input
          type="text"
          className="inputSelect__input"
          placeholder={displayPlaceholder}
          value={searchInField}
          onChange={onInputChange}
          onFocus={onFocus}
          autoComplete="disabled"
        />

        { InputIcon({ value, onResetInput, isNotDeleteButton, multi, isOpenOptions, handleOnClickCaret }) }
        {value && InputValues({ searchInField, value }) }
      </div>

      { InputDropdown({ options: filteredOptions, onSelectedOptions, selectedOptions, isOpenOptions, multi, isNotDeleteButton, allOptions: options })}
    </div>
  )
}
